import Vue from "vue";
import VueProgressBar from "vue-progressbar";
import { uuidPattern } from "../../lib/raft_generic_helper";
import "@/composables/useNotification";

const PickupRequestsListing = () =>
  import("../../components/hazardous_waste/PickupRequestsListing.vue");
const WasteGeneratorListing = () =>
  import("../../components/hazardous_waste/WasteGeneratorListing.vue");
const WasteProfileListing = () =>
  import("../../components/hazardous_waste/WasteProfileListing.vue");
const WasteStreamProfileForm = () =>
  import("../../components/hazardous_waste/WasteStreamProfileForm.vue");
const WastePickupRequestForm = () =>
  import("../../components/hazardous_waste/WastePickupRequestForm.vue");
const GroupPickupRequests = () =>
  import("../../components/hazardous_waste/GroupPickupRequests.vue");
const GroupAssignProfiles = () =>
  import(
    "../../components/hazardous_waste/AssignWasteStreamProfilesToGroup.vue"
  );
const PickupRequest = () =>
  import("../../components/hazardous_waste/PickupRequest.vue");
const ChemicalWasteStreamProfile = () =>
  import("../../components/hazardous_waste/ChemicalWasteStreamProfile.vue");
const ClosedRequestsInGroup = () =>
  import("../../components/hazardous_waste/ClosedRequestsInGroup.vue");

require("../../css/FixTableColumn.css");
require("./css/hazardous_waste_pickup.css");

const options = {
  color: "#41b883",
  failedColor: "#874b4b",
  thickness: "8px",
  transition: {
    speed: "0.02s",
    opacity: "0.8s",
    termination: 9000,
  },
  autoRevert: true,
  autoFinish: false,
  location: "top",
  inverse: false,
};
Vue.use(VueProgressBar, options);

const routes = [
  {
    path: "/raft/hazwaste/waste-generators",
    component: WasteGeneratorListing,
    name: "waste_generator_listing",
  },
  {
    path:
      "/raft/hazwaste/waste-stream-profile/view/chemical_waste_stream_profile/:wasteStreamProfileUuid(" +
      uuidPattern +
      ")?",
    component: ChemicalWasteStreamProfile,
    name: "waste_stream_profile_view",
    props: true,
  },
  {
    path: "/raft/hazwaste/waste-stream-profiles/create/chemical_waste_stream_profile",
    component: WasteStreamProfileForm,
    name: "chemical_waste_stream_profile_form",
  },
  {
    path:
      "/raft/hazwaste/waste-stream-profile/edit/chemical_waste_stream_profile/:uuid(" +
      uuidPattern +
      ")",
    component: WasteStreamProfileForm,
    name: "chemical_waste_stream_profile_edit_form",
    props: true,
  },
  {
    path:
      "/node/:groupNid([0-9]+)/hazwaste/request-pickup/create/:wasteStreamProfileBundle/:wasteStreamProfileUuid(" +
      uuidPattern +
      ")?",
    component: WastePickupRequestForm,
    name: "waste_pickup_request_create_form",
    props: true,
  },
  {
    path:
      "/node/:groupNid([0-9]+)/hazwaste/request-pickup/view/:pickupRequestUuid(" +
      uuidPattern +
      ")?",
    component: PickupRequest,
    name: "waste_pickup_request_view",
    props: true,
  },
  {
    path:
      "/node/:groupNid([0-9]+)/hazwaste/request-pickup/edit/:pickupRequestUuid(" +
      uuidPattern +
      ")?",
    component: WastePickupRequestForm,
    name: "waste_pickup_request_edit_form",
    props: true,
  },
  {
    path: "/node/:groupNid([0-9]+)/view/hazwaste",
    alias: "/node/:groupNid([0-9]+)/hazwaste",
    component: GroupPickupRequests,
    name: "group_waste_pickup_requests",
    props: true,
  },
  {
    path: "/node/:groupNid([0-9]+)/view/hazwaste/pickup-requests",
    alias: "/node/:groupNid([0-9]+)/hazwaste/pickup-requests",
    component: GroupPickupRequests,
    name: "group_waste_pickup_requests_alternate",
    props: true,
  },
  {
    path: "/node/:groupNid([0-9]+)/view/hazwaste/pickup-requests-closed",
    alias: "/node/:groupNid([0-9]+)/hazwaste/pickup-requests-closed",
    component: ClosedRequestsInGroup,
    name: "group_closed_waste_pickup_requests",
    props: true,
  },
  {
    path: "/node/:groupNid([0-9]+)/view/hazwaste/assign-profiles",
    alias: "/node/:groupNid([0-9]+)/hazwaste/assign-profiles",
    component: GroupAssignProfiles,
    name: "group_assign_waste_stream_profiles",
    props: true,
  },
  {
    path: "/raft/hazwaste/waste-stream-profiles",
    component: WasteProfileListing,
    props: { profileRequestState: "active" },
    name: "open_waste_stream_profiles_listing",
  },
  {
    path: "/raft/hazwaste/waste-stream-profiles/archived",
    component: WasteProfileListing,
    props: { profileRequestState: "archived" },
    name: "archived_waste_stream_profiles_listing",
  },
  {
    path: "/raft/hazwaste/pickup-requests",
    component: PickupRequestsListing,
    name: "base_open_pickup_requests_listing",
    props: { pickupRequestStatus: "open" },
  },
  {
    path: "/raft/hazwaste/pickup-requests/open",
    component: PickupRequestsListing,
    name: "open_pickup_requests_listing",
  },
  {
    path: "/raft/hazwaste/pickup-requests/closed",
    component: PickupRequestsListing,
    props: { pickupRequestStatus: "closed" },
    name: "closed_pickup_requests_listing",
  },
  {
    path:
      "/raft/hazwaste/pickup-request/edit/:pickupRequestUuid(" +
      uuidPattern +
      ")?",
    component: WastePickupRequestForm,
    props: (route) => ({
      pickupRequestUuid: route.params.pickupRequestUuid,
      closePickupRequestAction: true,
    }),
    name: "pickup_waste_pickup_request",
  },
];

export default routes;
